








































































import { Component, Vue } from 'vue-property-decorator'
import { OrderSettings } from '@/api/model/order-settings'
import { OrderType } from '@/api/types'
import { CompanyAPI } from '@/api/backend-client'
import { Pipeline } from '@/api/model/pipeline'
import { namespace } from 'vuex-class'
const referrals = namespace('referrals')

@Component
export default class OrdersPipelinesEnabled extends Vue {
    settingsLoading: boolean = false
    orderSettings: OrderSettings = null
    @referrals.State readonly loading!: boolean
    @referrals.State readonly pipelines!: Pipeline[]
    @referrals.Action loadPipelines!: () => Promise<void>

    async mounted(): Promise<void> {
        await this.loadContent()
    }

    async loadContent(): Promise<void> {
        await this.loadPipelines()
        this.settingsLoading = true
        this.orderSettings = await CompanyAPI.getOrderSettings(this.$currentCompany.id)
        this.orderSettings = this.orderSettings ?? OrderSettings.new(this.$currentCompany.id)
        this.settingsLoading = false
    }

    isEnabledType(type: OrderType): boolean {
        return this.orderSettings.enabledTypes.some(v => v === type)
    }

    onEnabledTypeChanged(field: OrderType, value: boolean) {
        if (value) {
            if (this.orderSettings.enabledTypes.some(v => v === field)) {
                return
            }

            this.orderSettings.enabledTypes.push(field)

        } else {
            this.orderSettings.enabledTypes = this.orderSettings.enabledTypes.filter(type => type !== field)
        }
    }

    getMappingValue(id: string): string|null {
        return this.orderSettings.pipelineMapping[id]
    }

    updateMapping(pipelineId: string, value: OrderType|null) {
        if (value === null) {
            delete this.orderSettings.pipelineMapping[pipelineId]
            this.$forceUpdate()
        }

        if (this.orderSettings.enabledTypes.includes(value)) {
            this.$set(this.orderSettings.pipelineMapping, pipelineId, value)
        }
    }

    async save(): Promise<void> {
        this.settingsLoading = true

        // clear old referral type mapping
        this.orderSettings.typeMapping = {}

        const orderSettings = await CompanyAPI.updateOrderSettings(this.$currentCompany.id, this.orderSettings)
        this.$set(this.$currentCompany, 'orderSettings', orderSettings)
        this.$notify({
            group: 'information',
            type: 'success',
            title: this.$t('company_settings.orders.success.title').toString(),
            text: this.$t('company_settings.orders.success.message').toString(),
        })
        this.settingsLoading = false
    }

    get enabledTypes(): Array<{ label: string, value: string }> {
        return this.orderSettings.enabledTypes.map(orderType => {
            return {
                label: this.$t(`order.type.${orderType}`).toString(),
                value: `${orderType}`,
            }
        })
    }

    get yesNoOptions(): Array<{ label: string, value: boolean }> {
        return [
            { label: this.$t('yes').toString(), value: true },
            { label: this.$t('no').toString(), value: false },
        ]
    }

    get availablePipelines(): Array<{ label: string, value: string }> {
        return this.pipelines.map(pipeline => {
            return {
                label: pipeline.name,
                value: pipeline.id,
            }
        })
    }
}
